module.exports = __webpack_public_path__ + "static/media/hotdog.48685ce8.jpeg";